module.exports = __webpack_public_path__ + "static/screencapture-argosvisual-2019-06-01-18_42_42-afa27366ef1bfce3e75d6238e952bd56.png";